import { useRef } from "react"

const useLongPress = (callback: (e: React.TouchEvent, ...args: any[]) => void, ms = 500) => {
    const timerRef = useRef<NodeJS.Timeout | null>(null)

    const start = (e: React.TouchEvent, ...args: any[]) => {
        timerRef.current = setTimeout(() => callback(e, ...args), ms)
    }

    const clear = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current)
            timerRef.current = null
        }
    }

    const getHandlers = (...args: any[]) => ({
        onTouchStart: (e: React.TouchEvent) => start(e, ...args),
        onTouchEnd: clear,
        onTouchMove: clear,
    })

    return getHandlers
};

export default useLongPress